import { React } from 'Imports';
import { VideoEventCommentResponse } from '$Generated/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import moment = require('moment');
import * as DateFormatter from '$Components/Shared/DateFormatter';
import { isEncompass } from '$Utilities/integrationPlatform';

interface CommentProps {
    eventComment: VideoEventCommentResponse;
    editable?: boolean;
    onEdit: (comment: VideoEventCommentResponse) => void;
}

const styles = require('./EventComments.scss') as {
    commentContainer: string;
    commentTextContainer: string;
    commentTextEncompass: string;
    commentTextGeotab: string;
    commentAuthorGeotab: string;
    commentAuthorEncompass: string;
    commentEditButtonGeotab: string;
    commentEditButtonEncompass: string;
};

export const Comment = (props: CommentProps) => {
    const createdOn = moment(props.eventComment.createdOn);
    const editedOn = moment(props.eventComment.editedOn);
    return (
        <div className={styles.commentContainer}>
            <div className={styles.commentTextContainer}>
                <div className={isEncompass ? styles.commentTextEncompass : styles.commentTextGeotab}>{props.eventComment.comment}</div>
                <div className={isEncompass ? styles.commentAuthorEncompass : styles.commentAuthorGeotab}>
                    Commented by {props.eventComment.createdBy} on {DateFormatter.date(createdOn)}
                    {editedOn > createdOn && ` (Edited)`}
                </div>
            </div>
            {props.editable && (
                <div>
                    <FontAwesomeIcon
                        icon={faEdit}
                        className={isEncompass ? styles.commentEditButtonEncompass : styles.commentEditButtonGeotab}
                        onClick={() => props.onEdit(props.eventComment)}
                    />
                </div>
            )}
        </div>
    );
};
